import { Link } from 'react-router'
import { useAuth } from '../auth'
import { Button, Card } from '../components/ui'
import { SetupForm } from './Mfa'

/** The signed-in person's own settings: authenticator, sessions. */
export function AccountPage() {
  const { me, refresh, signOut } = useAuth()
  if (!me) return null
  return (
    <div className="auth-page" style={{ alignItems: 'start' }}>
      <div style={{ width: '100%', maxWidth: 560 }} className="stack-lg">
        <div className="spread">
          <Link to="/" className="brand">
            <span className="brand-mark" /> Tabula
          </Link>
          <Link to="/" className="small">
            Back
          </Link>
        </div>
        <Card title="Your account">
          <dl className="detail-grid">
            <dt>Name</dt>
            <dd>{me.user.name ?? '—'}</dd>
            <dt>Email</dt>
            <dd>{me.user.email}</dd>
            <dt>Access</dt>
            <dd>{me.memberships.length ? me.memberships.map((m) => `${m.name} (${m.role})`).join(', ') : me.user.isPlatformAdmin ? 'Platform admin' : 'No restaurants yet'}</dd>
          </dl>
        </Card>
        <Card title="Authenticator app">
          {me.user.totpEnabled ? (
            <p className="small">
              Enabled. A code from your authenticator is asked for on every new sign-in. <span className="muted">Contact support to reset it if you lose the device.</span>
            </p>
          ) : (
            <SetupForm onDone={refresh} intro="Add a second factor: after your password or provider sign-in, Tabula will also ask for a 6-digit code from an authenticator app. Recommended for owners." />
          )}
        </Card>
        <Card title="Sessions">
          <div className="row-flex">
            <Button onClick={() => void signOut()}>Sign out</Button>
            <Button variant="danger" onClick={() => void signOut(true)}>
              Sign out everywhere
            </Button>
          </div>
          <p className="hint">"Everywhere" ends the session on every device and browser where you are signed in, including shared tablets.</p>
        </Card>
      </div>
    </div>
  )
}
